import { API_URL_FAQ } from "@constants/env";
import apiInstance from "@services/Shared/instanceAxios";

const deleteFaq = (uuid: string) =>
  apiInstance({
    url: API_URL_FAQ + uuid,
    method: "delete",
  });

export default deleteFaq;
